const initialState = {
  parts: [],
};

const part = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default part;
